import React from 'react'

interface ModalProps {
  accentColor?: string
  containerClassName?: string
  contentClassName?: string
  descriptionClassName?: string
  show: boolean
  handleClose?: () => void
  icon?: React.ReactNode
  title?: string
  titleClassName?: string
  description?: React.ReactNode
  children: React.ReactNode
}

const Modal: React.FC<ModalProps> = ({
  accentColor,
  containerClassName,
  contentClassName,
  descriptionClassName,
  show,
  handleClose,
  icon,
  title,
  titleClassName,
  description,
  children
}: ModalProps) => {
  if (!show) return null

  return (
    <div
      className="fixed inset-0 z-10 flex justify-center bg-black bg-opacity-50"
    >
      <div
        className={containerClassName || 'm-auto relative landscape:w-[400px] rounded-3xl bg-white p-4 shadow-lg portrait:w-full portrait:mx-4 portrait:border portrait:border-gray-200'}
      >
        {accentColor && (
          <div
            className="absolute inset-x-0 top-0 h-3 rounded-t-3xl"
            style={{ backgroundColor: accentColor }}
          />
        )}
        {handleClose && (
          <button type='button' onClick={handleClose} className='absolute top-4 right-4 text-2xl font-bold'>
            X
          </button>
        )}

        <div className={contentClassName || 'mt-2 flex flex-col items-center justify-center md:px-20 px-4 gap-4'}>
          {icon}
          {title && <h1 className={titleClassName || 'md:text-xl font-[\'Onest\'] text-2xl text-center font-medium'}>{title}</h1>}
          {description && <p className={descriptionClassName || 'text-gray-500 font-[\'Geist\'] md:text-sm text-base text-center portrait:px-12'}>{description}</p>}
        </div>
        {children}
      </div>
    </div>
  )
}

export default Modal
